import { Fragment, useEffect, useState, useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
import { notification, Spin, Modal, Pagination, Alert } from "antd";
import { useDispatch, useSelector } from "react-redux";
import cx from 'classnames'
import moment from "moment";
import {
  dashboarNotesListSearch,
  dashboardNoteDelete,
  reset,
} from "./redux/slice";
import EditNote from "../../modals/editNote";
import { dashboardEditNoteOpen } from "../../.config/redux/actions";
import { usePaggination, useSecurity, useStatusLeadColor } from "../../../../../../config/hooks";
import { P_ANNOUNCEMENT_NOTES, P_ANNOUNCEMENT_NOTES_HISTORY, P_GL_AGENTE_NOTES, P_GL_AGENTE_NOTES_HISTORY, P_GL_AREA_MANAGER_NOTES, P_GL_AREA_MANAGER_NOTES_HISTORY, P_TEAM_LEADS_NOTES_HISTORY, P_TEAM_LEADS_NOTES } from "../../../../../../config/helpers/permissionsHash";
import { RenderAnswersForm } from "../../../../../../components/RenderAnwsersForm";

const PERMISSIONS = {
  AGENTS: {
    notes: P_GL_AGENTE_NOTES,
    history_notes: P_GL_AGENTE_NOTES_HISTORY
  },
  PARTNER_AFFILIATI: {
    notes: P_ANNOUNCEMENT_NOTES,
    history_notes: P_ANNOUNCEMENT_NOTES_HISTORY
  },
  AREA_MANAGERS: {
    notes: P_GL_AREA_MANAGER_NOTES,
    history_notes: P_GL_AREA_MANAGER_NOTES_HISTORY
  },
  TEAM: {
    notes: P_TEAM_LEADS_NOTES,
    history_notes: P_TEAM_LEADS_NOTES_HISTORY
  }
}

const ListNotes = (props) => {
  const { companyAnnouncementId, additionalButtons = [], typeAnnouncement = 'COMPANY', ownerId, roleName = 'PARTNER_AFFILIATI' } = props;
  const dispatch = useDispatch();
  const { messages } = useIntl();

  const { user } = useSelector(state => state.authRedux)
  const [visibleDeleteAlert, setVisibleDeleteAlert] = useState(null);
  const { resultDelete, data, loading, error } = useSelector(
    (state) => state.dashboardNotesListRedux
  );

  const { data: companyAnnouncement } = useSelector(
    (state) => state.companyAnnouncementDetailRedux
  );
  const { data: userAnnouncement } = useSelector(
    (state) => state.userAnnouncementDetailRedux
  );
  const { data: teamAnnouncement } = useSelector(
    (state) => state.teamAnnouncementDetailRedux
  );

  const [announcementStatusList, getDetailStatusColor] = useStatusLeadColor();

  const typeoFNoticationMessage = (item) => {
    if (item == 0) {
      return {
        type: "warning",
        message: messages["listNotificacionStatusPending"],
        icon: 'bx-hourglass',
        typeAlert: 'warning'
      }
    } else if (item == 2) {
      return {
        type: "danger",
        message: messages["listNotificacionStatusError"],
        icon: 'bx-error',
        typeAlert: 'error'
      }
    } else {
      return {
        type: "success",
        message: messages["listNotificacionStatusSuccess"],
        icon: 'bx-check',
        typeAlert: 'success'
      }
    }
  } 

  const paggination = usePaggination(dashboarNotesListSearch, 10);
  useEffect(() => {
    if (companyAnnouncementId) {
      refresh();
    }
    return () => {
      dispatch(reset());
    };
  }, [companyAnnouncementId]);

  useEffect(() => {
    if (error) {
      notification.error({
        message: messages["saveError"],
        description: messages[error] || error,
      });
    }
    if (resultDelete) {
      notification.success({
        message: messages["deleteSucessfully"],
      });
      toggleDeleteAlert();
      refresh();
    }
  }, [error, resultDelete]);

  const C = useSecurity(PERMISSIONS[roleName].notes, ['C']);
  const R = useSecurity(PERMISSIONS[roleName].notes, ['R']);
  const U = useSecurity(PERMISSIONS[roleName].notes, ['U']);
  const D = useSecurity(PERMISSIONS[roleName].notes, ['D']);
  const historyAccess = useSecurity(PERMISSIONS[roleName].history_notes);

  const statusAlert = useCallback((statusId) => {
    if (announcementStatusList) {
       const _status = getDetailStatusColor(statusId)

      return <span role="alert" style={{backgroundColor: _status.backgroundColor, color: _status.textColor}} className={`alert`}>{_status?.name}</span>
    }

    return <></>
    
  }, [announcementStatusList])

  // Always "prommemorias" or programated notes are sent to the user, company user or team members that are associated with the announcement.
  const sendTo = useMemo(() => {
    let _sendTo = [];
    switch (typeAnnouncement) {
      case 'USER':
        _sendTo = [userAnnouncement?.user?.email];
        break;
      case 'TEAM':
        _sendTo = teamAnnouncement?.restrictionAccess ? [
          ...teamAnnouncement.restrictionAccess.agents.filter(item => item.hasAcess != 0).map(item => item.email),
          ...teamAnnouncement.restrictionAccess.affiliatedPartners.filter(item => item.hasAcess != 0).map(item => item.email),
          ...teamAnnouncement.restrictionAccess.areaManagers.filter(item => item.hasAcess != 0).map(item => item.email),
        ] : [];
        break;
      default:
        _sendTo = [companyAnnouncement?.user?.email]
        // COMPANY
        break;
    }
    return _sendTo
  }, [typeAnnouncement, userAnnouncement, companyAnnouncement, teamAnnouncement]);

  const refresh = () => {
    paggination.refresh(null, null, {
      all: historyAccess,
      companyAnnouncementId: parseInt(companyAnnouncementId),
      typeAnnouncement
    });
  };

  const toggleDeleteAlert = (id = null) => setVisibleDeleteAlert(id);

  return (
    <Fragment>
      <Spin spinning={loading}>
        <div className="row mb-2">
          <div className="col-6">  <h5 className="card-header">{messages["dashboardDetail_notes"]}</h5></div>
          <div className="col-6 d-flex justify-content-end">
            {additionalButtons}
            {R && <button
              className="btn btn-primary me-sm-3 me-1"
              onClick={() => {
                refresh();
              }}
            >
              {messages["refresh"]}
            </button>}
            {C && <button
              className="btn btn-primary me-sm-3 me-1"
              onClick={() => {
                dispatch(dashboardEditNoteOpen({ companyAnnouncementId, typeAnnouncement }));
              }}
            >
              {messages["dashboardDetail_notesAdd"]}
            </button>}
          </div>
          {R && <div>
            <Pagination defaultCurrent={paggination.page} total={data?.count} pageSize={10} onChange={paggination.tablePaggination.onChange} />
          </div>}
        </div>

        {R &&
          data?.items?.map(item => {
            return (
              <div key={item.id} className={cx("card mb-3 row", item.isDeleted && 'bg-label-danger')}>
                <div className="card-header">
                  <div className="d-flex align-items-start">
                    <div className="d-flex justify-content-between flex-grow-1">
                      <div className="me-2">
                        <h5 className="mb-1">{`${item?.created?.firstName} ${item?.created?.lastName} `} {!ownerId ||item?.companyId == ownerId || item?.userId == ownerId ? '' : '/' + messages['listNotificacion_isAdmin']}</h5>
                        <div className="client-info d-flex align-items-center">
                          <h6 className="mb-0 me-1">{moment(item.createdOn).format("DD/MM/yyyy H:mm")}</h6>
                        </div>
                      </div>
                      {item?.form?.statusId && <span className="me-2">{statusAlert(item.form.statusId)}</span>}
                      {item?.emailSchedule && <div className="d-flex align-items-center me-2">
                        <h6 className="mb-0 me-2">{`${messages["listNotificacionStatusEmail"]} ${moment(item?.emailSchedule).format("DD/MM/yyyy HH:mm")}`}</h6>
                        <Alert
                          message={typeoFNoticationMessage(item?.sendStatus).message}
                          type={typeoFNoticationMessage(item?.sendStatus).typeAlert}
                          showIcon
                          icon={<span style={{height: 25, width: 25}} className={cx("badge rounded-pill text-white p-0 d-flex justify-content-center align-items-center",  "bg-" + typeoFNoticationMessage(item?.sendStatus).type)}>
                            <i className={cx("icon-base bx icon-md", typeoFNoticationMessage(item?.sendStatus).icon)} />
                          </span>}
                        />
                      </div>}
                    </div>
                    {
                      !item?.isDeleted && (user?.id == item?.created?.id) &&
                      <div className="ms-auto">
                        <div className="dropdown zindex-2">
                          <button type="button" className="btn dropdown-toggle hide-arrow p-0" data-bs-toggle="dropdown" aria-expanded="false"><i className="bx bx-dots-vertical-rounded"></i></button>
                          <ul className="dropdown-menu dropdown-menu-end">
                            {U && <li><a className="dropdown-item" onClick={() => { dispatch(dashboardEditNoteOpen({ id: item?.id, companyAnnouncementId, typeAnnouncement })) }}>{messages['edit']}</a></li>}
                            <li>
                              <hr className="dropdown-divider" />
                            </li>
                            {D && <li><a className="dropdown-item text-danger" onClick={() => { toggleDeleteAlert(item?.id) }}> {messages["delete"]}</a></li>}
                          </ul>
                        </div>
                      </div>
                    }
                  </div>
                </div>
                <div className="card-body row">
                  <div className="col-12 col-md-8">
                    {item?.form ?
                      <div>
                        <RenderAnswersForm answers={item?.formAnswer} form={item?.form} />
                      </div> :
                      <p className="mb-0">{item.note}</p>
                    }
                  </div>
                  <div className="col-12 col-md-4 text-end">
                    {item?.emailSchedule && sendTo && sendTo.length > 0 ?
                      <ul className="text-start" style={{listStyle: 'none'}}>
                        {sendTo.map((email, i) => <li className="row mb-1" key={i}>
                            <span style={{height: 25, width: 25}} className={cx("badge rounded-pill text-white p-0 d-flex justify-content-center align-items-center me-1",  "bg-" + typeoFNoticationMessage(item?.sendStatus).type)}>
                              <i className={cx("icon-base bx icon-md", typeoFNoticationMessage(item?.sendStatus).icon)} />
                            </span>
                            {email}
                          </li>)}
                      </ul>
                      : <></>
                    }
                    {
                      historyAccess && item.changes?.length > 0 &&
                      <div>
                        <span className="badge bg-label-warning ms-auto">{
                          messages["listNotificacion_motification"]
                        }</span>
                        <br />
                        <span className="text-body fw-normal">{moment(item.updatedOn).format("DD/MM/yyyy HH:mm")}</span>
                      </div>
                    }
                  </div>
                </div>
                { 
                  historyAccess &&
                  item?.changes?.map((child, i) => {
                    return (
                      <div key={i} className={cx("card-body border-top", "bg-label-secondary")}>
                        <div className="d-flex justify-content-between flex-grow-1 mb-3">
                          <div className="me-2">
                            <h5 className="mb-1">{`${child?.created?.firstName} ${child?.created?.lastName}`}{!ownerId || item?.companyId == ownerId || item?.userId == ownerId ? '' : '/' + messages['listNotificacion_isAdmin']}</h5>
                            <div className="client-info d-flex align-items-center">
                              <h6 className="mb-0 me-1">{moment(child.createdOn).format("DD/MM/yyyy HH:mm")}</h6>
                            </div>
                          </div>
                          {child?.emailSchedule && <h6 className="mb-0 me-2">{`${messages["listNotificacionStatusEmail"]} ${moment(child?.emailSchedule).format("DD/MM/yyyy HH:mm")}`}</h6>}
                        </div>
                        <p className="mb-0">{child.note}</p>
                      </div>
                    )
                  })
                }
              </div>
            )
          })
        }

        <EditNote
          onClose={(ref) => {
            ref && refresh();
          }}
        />
        <Modal
          open={!!visibleDeleteAlert}
          title={messages["dashboardDetail_deleteNote"]}
          onCancel={() => toggleDeleteAlert()}
          footer={null}
          maskClosable={false}
        >
          <div className="p-3 p-md-2">
            <div className="modal-body">
              <div>
                <h6 className="card-subtitle mb-0">
                  {" "}
                  {messages["dashboardDetail_deleteNoteDescription"]}
                </h6>
              </div>
            </div>
            <div className="row pt-5">
              <div className="col-12 text-center">
                <button
                  type="button"
                  className="btn btn-primary me-sm-3 me-1"
                  onClick={() => dispatch(dashboardNoteDelete({ id: visibleDeleteAlert }))}
                //loading={loading}
                >
                  {messages["delete"]}
                </button>
                <button
                  type="button"
                  className="btn btn-label-secondary"
                  onClick={() => toggleDeleteAlert()}
                >
                  {messages["cancel"]}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Spin>
    </Fragment>
  );
}

export default ListNotes